module.exports = __webpack_public_path__ + "static/media/ASC Junes 2020 Top Five_1590070030956.83befa04.pptx";